import React from 'react';
import { useTranslator } from '@jutro/locale';
import styles from './PolicyDocumentError.module.scss';
import messages from './PolicyDocumentError.messages';
import { Icon } from '@jutro/legacy/components';

export default function PolicyDocumentError() {
    const translator = useTranslator();
    return (
        <div>
            <Icon icon="mi-warning" className={styles.exclamationIcon} />
            <span>{translator(messages.unableToAccessDocument)}</span>
        </div>
    );
}
